import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import { Button } from '../../components/ui/button';
import {
  LayoutDashboard,
  Building2,
  Target,
  Package,
  Lightbulb,
  Award,
  BarChart3,
  Mail,
  LogOut,
  Droplet
} from 'lucide-react';

const AdminLayout = () => {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/company', icon: Building2, label: 'Company Info' },
    { path: '/admin/vision-mission', icon: Target, label: 'Vision & Mission' },
    { path: '/admin/products', icon: Package, label: 'Products' },
    { path: '/admin/innovations', icon: Lightbulb, label: 'Innovations' },
    { path: '/admin/usps', icon: Award, label: 'USPs' },
    { path: '/admin/stats', icon: BarChart3, label: 'Stats' },
    { path: '/admin/inquiries', icon: Mail, label: 'Inquiries' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 w-64 bg-gray-900 text-white">
        <div className="p-6">
          <div className="flex items-center space-x-2 mb-8">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-lg flex items-center justify-center">
              <Droplet className="w-6 h-6" />
            </div>
            <div>
              <div className="font-bold">CJS Admin</div>
              <div className="text-xs text-gray-400">Content Management</div>
            </div>
          </div>

          <nav className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-teal-600 text-white'
                        : 'text-gray-300 hover:bg-gray-800'
                    }`
                  }
                >
                  <Icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </NavLink>
              );
            })}
          </nav>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-gray-800">
          <div className="text-sm text-gray-400 mb-4">
            Logged in as:<br />
            <span className="text-white">{admin?.email}</span>
          </div>
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full border-gray-700 text-gray-300 hover:bg-gray-800"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </div>

      {/* Main Content */}
      <div className="ml-64">
        <div className="p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
